import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import Image from "@components/image";

const BlogRollItem = ({ post }) => {
  return (
    <div className="blog-post">
      <Link to={post.slug}>
        <div className="featured-image">
          <Image src={post.hero.full} alt={post.title} />
        </div>
        <div className="content">
          <div className="post-title">{post.title}</div>
          <span className="blog-date">
            {post.date} &middot; {post.timeToRead}
          </span>
          <p className="ar-subtitle">{post.excerpt}</p>
          <div className="post-meta">
            <div className="author-block">
              <div className="image is-32x32">
              {post.author === "Balazs Pozner" && <img src="/img/balazs_pozner.jpg" alt="balazs pozner" /> }
              {post.author === "Samuele Gugliotta" && <img src="/img/venomnis.jpeg" alt="venomnis" /> }
              {post.author === "Levente Molnar" && <img src="/img/levente-molnar.jpeg" alt="Levente Molnar" /> }
              </div>
              <div className="author-name">
                <span>by {post.author}</span>
                <span>
                  <small>in</small> {post.tags.join()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};
BlogRollItem.propTypes = {
  post: PropTypes.object.isRequired,
};

export default BlogRollItem;
